import axios from "axios";
import apiClient from "../utils/apiClient";

export const getAllFlows = async () => {
  try {
    const response = await apiClient().get(`call_flows/`);

    return response.data;
  } catch (error) {
    console.error("Error while getting all flows data", error);
    //return error
  }
};

export const getFlowById = async (id) => {
  try {
    const response = await apiClient().get(`call_flows/${id}/`);
    return response.data;
  } catch (error) {
    console.error("Error while getting flow by Id", error);
    //return error
  }
};

export const setFlowById = async (id, data) => {
  try {
    const response = await apiClient().put(`call_flows/${id}/`, data);
    return response;
  } catch (error) {
    console.error("Error while setting flow by id", error);
    //return error
  }
};

export const deleteFlowById = async (id) => {
  try {
    const response = await apiClient().delete(`call_flows/${id}/`);
  } catch (error) {
    console.error("Error while deleting flow by id", error);
    //return error
  }
};

export const getFlowsByWorkspaceId = async (workspace_id) => {};

//{
//    name: name,
//    initial_nodes: null,
//    initial_edges: null,
//    interruptions: null,
//    backend_json: null,
//    approved_backend_json: null,
//    last_approved: null,
//    approval_status: null,
//    workspace_id: "93443da8-7703-11ee-b962-0242ac120016"
//}

export const createFlow = async (name, workspace_id) => {
  try {
    const data = {
      name: name,
      workspace_id: workspace_id,
    };
    const response = await apiClient().post(`call_flows/`, data);

    return response;
  } catch (error) {
    console.error("Error while creating flow", error);
    //return error
  }
};

export const makeCall = async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_TELESERVER_URL}make_call_`,
      data
    );

    return response;
  } catch (error) {
    console.error("Error while make call", error);
    //return error
  }
};

//{
//    "id": "ce0c5460-4ea4-4567-b33b-1b281335aa36", NR
//    "name": "temp_flow",
//        "initial_nodes": null,
//            "initial_edges": null,
//                "interruptions": null,
//                    "backend_json": null,
//                        "approved_backend_json": null,
//                            "last_approved": null,
//                                "approval_status": null,
//                                    "workspace_id": "93443da8-7703-11ee-b962-0242ac120001", fixed: : point_up_2:
//    "created_at": "2023-10-30T09:06:20.692335Z", NR
//    "updated_at": "2023-10-31T01:42:16.767236Z" NR
//}
